import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ScreenError404 } from '@/components/screens';
import { routes } from '@/routers';
import { useEffect, useMemo, useRef } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useRoutes } from 'react-router-dom';
import { TooltipProvider } from './components/ui/tooltip';
import { usePartyStore } from './features/parties/store/usePartyStore';
import { RouteGuard } from './hoc';
import useStore from './lib/store';

function App() {
  const { user } = useStore();
  const { fetchCropTypes, fetchCropGenerations, fetchParties } =
    usePartyStore();

  const initialDataFetched = useRef(false);
  useEffect(() => {
    if (user && !initialDataFetched.current) {
      initialDataFetched.current = true;
      Promise.allSettled([
        fetchParties(),
        fetchCropTypes(),
        fetchCropGenerations(),
      ]);
    }
    if (!user) initialDataFetched.current = false;
  }, [user]);

  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000, // 5 minutes
          },
        },
      }),
    [],
  );

  return (
    <ErrorBoundary>
      <RouteGuard>
        <TooltipProvider>
          <QueryClientProvider client={queryClient}>
            {useRoutes([
              ...routes(),
              {
                path: '*',
                element: <ScreenError404 />,
              },
            ])}
          </QueryClientProvider>
        </TooltipProvider>
      </RouteGuard>
    </ErrorBoundary>
  );
}

export default App;
